export interface PVQSettings {
  autoCheckFieldCompleteness: boolean;
  aiValidationThreshold: 'low' | 'medium' | 'high';
  encouragingFeedback: boolean;
  performComprehensiveReview: boolean;
  useKnowledgeBase: boolean;
  useAdvancedRAG: boolean;
  selectedProjectId: string | null;
  showPOCLinks: boolean;
}

export const DEFAULT_SETTINGS: PVQSettings = {
  autoCheckFieldCompleteness: false,
  aiValidationThreshold: 'medium',
  encouragingFeedback: true,
  performComprehensiveReview: true,
  useKnowledgeBase: false,
  useAdvancedRAG: true,  // Local RAG mode by default
  selectedProjectId: null,  // Will be set to first available project
  showPOCLinks: true  // Show POC links by default
};

export const getSettings = (): PVQSettings => {
  try {
    const savedSettings = localStorage.getItem('pvq-settings');
    if (savedSettings) {
      const parsed = JSON.parse(savedSettings);
      // Merge with defaults to ensure all properties exist
      return { ...DEFAULT_SETTINGS, ...parsed };
    }
  } catch (error) {
    console.error('Error loading settings:', error);
  }
  return DEFAULT_SETTINGS;
};

export const saveSettings = (settings: PVQSettings): void => {
  try {
    localStorage.setItem('pvq-settings', JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving settings:', error);
  }
};